// 默认是保存token，目前本地保存了token和用户信息(userInfo)
const val = 'ez_token'

// 保存token
export function saveToken(token, key = val){
    window.localStorage.setItem(key,token)
}

// 获取token
export function getToken(key = val) {
   return window.localStorage.getItem(key)
  }

// 删除token
export function removeToken(key = val) {
    window.localStorage.removeItem(key)
}
